import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import './styles/global.scss';
import momentTimezone from 'moment-timezone';
import moment from 'moment';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

momentTimezone.tz.setDefault(moment.tz.guess());

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
